<script lang="ts">
	import Text from '$lib/components/ui/text/text.svelte';
	import { navLinks } from './navLinks';
	import { t } from '$lib/i18n';
</script>

<div class="flex flex-col items-center bg-[#0D0320] p-5">
	<div class=" mb-5">
		<img src="/img/landing/footer/logo.png" alt="chain_party_logo" class="h-[80px] w-[80px]" />
	</div>
	<div class="mb-5 hidden gap-[60px] xl:flex">
		{#each navLinks as link}
			<a href={link.path} target={link.name === 'Mechanism' ? 'blank' : ''}>
				<Text size="lg" class="pixel-font text-[25px] hover:text-[#EC05F8]">
					{$t(`landing.nav_links.${link.name}`)}
				</Text>
			</a>
		{/each}
	</div>
	<Text size="sm" class="text-[#8679B2]">{$t('common.copyright')}</Text>
</div>
